import React from 'react'
import LandingSheet from './LandingSheet';
import FullStackSection from './FullStackSheet';
import DataBaseSection from './DataBaseSheet';
import MachineLearningSection from './MachineLearningSheet';
import CompetitiveCodingSection from './CodingSheet';
import ServicesSection from './ServicesSheet';
import Layout from '../../layouts/Layout';

function Home() {
    return (
        <Layout header={2} footer={2} className="black-background">
          {/* <BrandArea /> */}
          {/* <AboutAreaTwo /> */}
          {/* <ServicesAreaTwo /> */}
          <LandingSheet />  
          <FullStackSection />
          <DataBaseSection />
          <MachineLearningSection />
          <CompetitiveCodingSection />
          <ServicesSection />
          {/* <CounterArea /> */}
          {/* <TestimonialArea /> */}
          {/* <DeveloperArea /> */}
           {/* <ProjectAreaTwo /> */}
          {/*<PricingArea />
          <WorkArea />
          <BlogAreaTwo /> */}
          {/* <Contact /> */}
        </Layout>
      );
}

export default Home